import React, { useContext, useEffect, useState } from "react";
import BottomBar from "components/bottom-bar";
import { Button } from "components/button";
import LoadingSpinner from "components/loading-spinner";
import AuthContext from "../../contexts/AuthContext";

const doCan = async (accessToken, { setCan }) => {
  try {
    const response = await fetch(`/api/export/takeback/can`, {
      headers: { Authorization: `Bearer ${accessToken}` },
    });

    if (!response.ok) {
      throw new Error(`Can not: ${response.status}`);
    }

    setCan(true);
  } catch (error) {
    console.error(error);
    setCan(false);
  }
};

const doExport = async (id, { accessToken, entityType }) => {
  try {
    const response = await fetch(`/api/export/${entityType}/${id}`, {
      headers: { Authorization: `Bearer ${accessToken}` },
    });

    if (!response.ok) {
      throw new Error(`Response not OK: ${response.status}`);
    }

    const blob = await response.blob();
    const urlBlob = window.URL.createObjectURL(blob);
    const link = document.createElement(`a`);
    const disposition = response.headers.get(`Content-Disposition`);
    const match =
      disposition.match(/filename="([^"]+)"/i) ||
      disposition.match(/filename=([^;]+)/i);

    link.href = urlBlob;
    link.setAttribute(`download`, match[1].trim());
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(urlBlob);
  } catch (error) {
    console.error(error);
    alert(`Error occured. Please try again`);
  }
};

export default function Admin() {
  const [can, setCan] = useState();
  const { authTokens } = useContext(AuthContext);
  const accessToken = authTokens?.access_token;
  const handleExportAllTakebacks = () => {
    doExport(`*`, { accessToken, entityType: `takeback` });
  };
  const handleExportAllCustomers = () => {
    doExport(`*`, { accessToken, entityType: `customer` });
  };

  useEffect(() => {
    doCan(accessToken, { setCan });
  }, [accessToken]);

  if (can === undefined) {
    return <LoadingSpinner />;
  }

  if (!can) {
    return <h1 className="m-10">403</h1>;
  }

  return (
    <div className="flex flex-col h-[calc(100vh-81px)]">
      <div className="flex flex-grow flex-col items-center justify-center px-6 py-4">
        <h1 className="text-primary text-6xl text-center mb-regular">Admin</h1>
        <p className="text-secondary text-center sm:max-w-sm mb-x-large">
          Export
        </p>
        <div className="flex flex-col gap-4">
          <Button onClick={handleExportAllTakebacks}>
            Export all takebacks
          </Button>
          <Button onClick={handleExportAllCustomers}>
            Export all customers
          </Button>
        </div>
      </div>
      <BottomBar />
    </div>
  );
}
